import { render, staticRenderFns } from "./ExcelFormattedOrders.vue?vue&type=template&id=2c0005af&scoped=true&"
import script from "./ExcelFormattedOrders.vue?vue&type=script&lang=js&"
export * from "./ExcelFormattedOrders.vue?vue&type=script&lang=js&"
import style0 from "./ExcelFormattedOrders.vue?vue&type=style&index=0&id=2c0005af&scoped=true&lang=css&"
import style1 from "./ExcelFormattedOrders.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0005af",
  null
  
)

export default component.exports